// QuoteDashboardSkeletonItem.tsx
import React from "react";

export const QuoteDashboardSkeletonItem: React.FC = () => (
    <div className="border border-slate-200 rounded-lg bg-white mb-4 shadow-sm overflow-hidden animate-pulse">
        <div className="p-4 space-y-4">
            <div className="flex justify-between">
                <div className="flex items-start space-x-3">
                    <div className="h-10 w-10 bg-slate-200 rounded-md" />
                    <div>
                        <div className="h-4 w-48 bg-slate-200 rounded mb-2" />
                        <div className="h-3 w-32 bg-slate-200 rounded" />
                    </div>
                </div>
                <div className="h-8 w-24 bg-slate-200 rounded" />
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-2">
                {[...Array(4)].map((_, i) => (
                    <div key={i} className="h-3 w-full bg-slate-200 rounded" />
                ))}
            </div>

            <div className="flex gap-2 mt-2">
                <div className="h-6 w-20 bg-slate-200 rounded-full" />
                <div className="h-6 w-24 bg-slate-200 rounded-full" />
            </div>
        </div>
    </div>
);
